import React from 'react';
import { GridWrapper } from '@yme/atoms/grid';
import { isForOwnersPdpCardEmpty } from '@yme/components/ForOwnersPdpCard/helpers';
import { useSelector } from '@yme/hooks/useSelector';
import { ForOwnersCard } from '@yme/molecules/cards';
import { getRTL } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
export function ForOwnersPdpCard(props) {
    const { title, description, link, image } = props;
    const isRightToLeft = useSelector(getRTL);
    const { t } = useTranslation();
    if (isForOwnersPdpCardEmpty(props)) {
        return null;
    }
    return (React.createElement(GridWrapper, null,
        React.createElement(ForOwnersCard, { cardProps: {
                title,
                countLineVisible: 'initial',
                description,
                link,
                image,
                labelLink: t('common_readMore_link'),
            }, isRightToLeft: isRightToLeft })));
}
ForOwnersPdpCard.displayName = 'ForOwnersPdpCard_AEMComponent';
